// @ts-nocheck
import React from 'react';

export interface AppIdPackageIdRowProps {
  game: any;
  style: React.CSSProperties;
}

function AppIdPackageIdRow({ game, style }: AppIdPackageIdRowProps) {
  return (
    <div className="grid-empty num" style={style}>
      {game.isSKU ? game.packageId : game.appId}
    </div>
  );
}

export default AppIdPackageIdRow;
